import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithPreview } from 'common/components/TouchpointEditor/components/TouchpointNodes/Button';
import { getEventPageRegisterUrl } from 'common/components/TouchpointEditor/utils';

const eventPageRegisterUrl = getEventPageRegisterUrl();

export default function RegisterButton(props) {
    const meta = { ...props.meta, href: eventPageRegisterUrl };
    return <ButtonWithPreview {...props} meta={meta} />;
}

RegisterButton.propTypes = {
    meta: PropTypes.object.isRequired,
};

RegisterButton.splash = ButtonWithPreview.splash;
